var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#C79A00",
  fillOpacity: 0.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m27.436 11.764c0.5983 0.6207 0.8979 1.3731 0.8979 2.2557v15.147l-8.2615-5.2997-8.4052 5.2997v-15.147c0-0.8826 0.2988-1.635 0.8979-2.2557 0.599-0.62 1.3169-0.9311 2.1556-0.9311h10.56c0.8374 0 1.556 0.3111 2.155 0.9311z",
  clipRule: "evenodd",
  fill: "#001246",
  fillRule: "evenodd"
})));
export default SvgBookmark;